"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var routes_1 = require("../../routes");
var RouterComponents_1 = require("./RouterComponents");
var ClaimForm_1 = require("./ClaimForm");
var ProductsGrid_1 = require("./ProductsGrid");
var Breadcrumbs_1 = require("./Breadcrumbs");
var PartnerPage = /** @class */ (function (_super) {
    tslib_1.__extends(PartnerPage, _super);
    function PartnerPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PartnerPage.prototype.render = function () {
        var _a = this.props.store.data, partner = _a.partner, products = _a.products;
        if (!partner) {
            return react_1.default.createElement(RouterComponents_1.NotFoundPage, null);
        }
        return (react_1.default.createElement("div", { className: "partner" },
            partner.meta && react_1.default.createElement(RouterComponents_1.Meta, { meta: partner.meta }),
            react_1.default.createElement("div", { className: "section section_grey section_less-padding" },
                react_1.default.createElement("div", { className: "wrapper wrapper_big" },
                    react_1.default.createElement(Breadcrumbs_1.Breadcrumbs, { items: [
                            {
                                name: 'Главная',
                                href: '/',
                            },
                            {
                                name: 'Партнеры',
                                href: routes_1.Routes.partners,
                            },
                            {
                                name: partner.name,
                            },
                        ] }),
                    react_1.default.createElement("h2", { className: "partner__name" }, partner.name),
                    partner.description && (react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                            __html: partner.description,
                        } })),
                    products.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("h3", { className: "content-header" }, "\u041F\u0440\u043E\u0434\u0443\u043A\u0446\u0438\u044F"),
                        react_1.default.createElement(ProductsGrid_1.ProductsGrid, { items: products }))))),
            react_1.default.createElement(ClaimForm_1.ClaimFormSection, null)));
    };
    PartnerPage = tslib_1.__decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], PartnerPage);
    return PartnerPage;
}(react_1.default.Component));
exports.PartnerPage = PartnerPage;
